
const localeMap = {
  en: { native: 'English', regionalCode: 'en-GB' },
  de: { native: 'Deutsch', regionalCode: 'de-DE' },
  fr: { native: 'Français', regionalCode: 'fr-FR' },
  ja: { native: '日本語', regionalCode: 'ja-JP' },
  es: { native: 'Español', regionalCode: 'es-ES' },
  it: { native: 'Italiano', regionalCode: 'it-IT' },
  pt: { native: 'Português', regionalCode: 'pt-PT' },
  nl: { native: 'Nederlands', regionalCode: 'nl-NL' },
  ms: { native: 'Bahasa Melayu', regionalCode: 'ms-MY' },
  th: { native: 'ไทย', regionalCode: 'th-TH' },
  fil: { native: 'Filipino', regionalCode: 'fil-PH' },
  zh: { native: '中文', regionalCode: 'zh-CN' },
  ar: { native: 'العربية', regionalCode: 'ar-SA' },
}
import { i18n } from '~/config/i18n'
import { mapGetters } from 'vuex'
export default {
  name: 'UiMainMenu',
  computed: {
    ...mapGetters({
      activeLocale: 'locale',
    }),
    translations() {
      return i18n.locales
        .map((locale) => ({
          code: locale.code,
          name: localeMap[locale.code].native || locale.name,
          regionalCode: localeMap[locale.code].regionalCode,
        }))
        .sort((a, b) => a.code.localeCompare(b.code))
    },
  },
  methods: {
    changeLocale(localeCode) {
      this.$store.commit('setLocale', localeMap[localeCode].regionalCode)
    },
  },
}
